/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { type AppDispatch } from '../../../store'
import { siteListLoadingAction, siteListUpdateAction, siteListErrorAction } from './siteListSlice'
import * as SiteListService from '../services/siteListService'
import { siteDeleteLoadingAction, siteDeleteUpdateAction, siteDeleteErrorAction } from './siteDeleteSlice'
import * as SiteDeleteService from '../services/siteDeleteService'
import { createSiteLoadingAction, createSiteUpdateAction, createSiteErrorAction } from './createSiteSlice'
import * as CreateSiteService from '../services/createSiteService'
import { type CreateSiteApiResponse, type CreateSitePostRequest } from '../services/createSiteService'
import { ImageUploadLoadingAction, ImageUploadUpdateAction, ImageUploadErrorAction } from './imageUploadSliceSite'
import { type ImageUploadApiResponse, type ImageUploadPostRequest } from '../services/imageUploadService'
import * as ImageUploadService from '../services/imageUploadService'
import { siteInfoLoadingAction, siteInfoUpdateAction, siteInfoErrorAction } from './siteInfoSlice'
import * as SiteInfoService from '../services/siteInfoService'
import { downloadImageLoadingAction, downloadImageUpdateAction, downloadImageErrorAction } from './downloadImageSliceSite'
import * as DownloadImageService from '../services/downloadImageService'
import { type UpdateSiteApiResponse, type UpdateSitePutRequest } from '../services/updateSiteService'
import * as UpdateSiteService from '../services/updateSiteService'
import { updateSiteLoadingAction, updateSiteUpdateAction, updateSiteErrorAction } from './updateSiteSlice'

export const fetchSiteList =
(PageNumber: number, PageItems: number, searchKey: string, SortParams: string, sortField: string) =>
  async (dispatch: any): Promise<void> => {
    dispatch(siteListLoadingAction())
    void SiteListService.getSiteList(
      PageNumber,
      PageItems,
      searchKey,
      SortParams,
      sortField,
      (siteList, httpStatus) => {
        dispatch(siteListUpdateAction({ data: siteList.sites, count: siteList.total_count, httpStatus }))
      },
      (errorMessage, httpStatus) => {
        dispatch(siteListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const siteDeleteCampaign = (selectedSiteId: string, selectedSiteName: string) => async (dispatch: any): Promise<void> => {
  dispatch(siteDeleteLoadingAction())
  void SiteDeleteService.siteDeleteCampaign(selectedSiteId, selectedSiteName,
    (deleteStatusData, httpStatus) => {
      dispatch(
        siteDeleteUpdateAction({
          data: deleteStatusData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(siteDeleteErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const createSite = (createSitePostRequest: CreateSitePostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createSiteLoadingAction())
  void CreateSiteService.createSite(
    createSitePostRequest,
    (CreateSiteApiResponse: CreateSiteApiResponse, httpStatus: number) => {
      dispatch(
        createSiteUpdateAction({
          data: CreateSiteApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createSiteErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const imageUpload = (imageUploadPostRequest: ImageUploadPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(ImageUploadLoadingAction())
  void ImageUploadService.imageUpload(
    imageUploadPostRequest,
    (imageUploadApiResponse: ImageUploadApiResponse, httpStatus: number) => {
      dispatch(
        ImageUploadUpdateAction({
          data: imageUploadApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(ImageUploadErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchSiteInfo = (selectedSiteId: string) => async (dispatch: any): Promise<void> => {
  dispatch(siteInfoLoadingAction())
  void SiteInfoService.fetchSiteInfo(selectedSiteId,
    (siteInfoData, httpStatus) => {
      dispatch(
        siteInfoUpdateAction({
          data: siteInfoData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(siteInfoErrorAction({ errorMessage, httpStatus }))
    }
  )
}

/* istanbul ignore next */
export const downloadImage = (siteId: string, locale: string) => async (dispatch: any): Promise<void> => {
  dispatch(downloadImageLoadingAction())
  void DownloadImageService.downloadImage(siteId, locale,
    (downloadImageData, httpStatus) => {
      dispatch(
        downloadImageUpdateAction({
          data: downloadImageData,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(downloadImageErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const updateSite = (updateSitePutRequest: UpdateSitePutRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(updateSiteLoadingAction())
  void UpdateSiteService.updateSite(
    updateSitePutRequest,
    (UpdateSiteApiResponse: UpdateSiteApiResponse, httpStatus: number) => {
      dispatch(
        updateSiteUpdateAction({
          data: UpdateSiteApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(updateSiteErrorAction({ errorMessage, httpStatus }))
    }
  )
}
